import { Goal, GoalProgressCount, ID } from '@griply/types';

import { getGoalAchievedPercentage } from './get-goal-achieved-percentage';

export const hasGoalReachedTarget = (
  goal: Goal,
  goalProgressCounts?: Map<ID, GoalProgressCount>,
): boolean => (getGoalAchievedPercentage(goal, goalProgressCounts) ?? 0) >= 100;
